import { IconButton as MuiIconButton } from '@mui/material';

export default MuiIconButton;
